import app from 'app';
import address from 'pages/customer/address';
import emailValidation from 'pages/customer/email-validation';
import passwordValidation from 'pages/customer/password-validation';

app.add({
  'customer-address': address,
  'email-validation': emailValidation,
  'password-validation': passwordValidation,
});
